import Header from '../../components/Header';
import './Login.css';
import DynamicForm from '../../components/dynamicForm';
import { useNavigate } from 'react-router-dom'
import { login } from '../../formData/login';

export default function Login() {
    const navigate = useNavigate()

    const handleAction = (action, data) => {


        console.log('ACTION:', action, 'DATA:', data);
        if (action === 'next') {
            navigate('/admin/');
        }
    };

    return (
        <div className="signup-page">
            <Header />
            <div className="login-content">
                <main className="login-main">
                    <div className='centered-alight-login-comp'>
                        <div className='formTitle'>Log in to AID Account</div>
                        <p className="signup-desc">
                            Welcome back! Please enter your details.
                        </p>

                        <DynamicForm schema={login} onAction={handleAction} />

                        <p className="login-prompt">
                            Don’t have an account? <a href="/">Sign up</a>
                        </p>
                    </div>
                </main>
            </div>
        </div>
    );
}
